/* eslint-disable */
export default {
  dial: 'Wählen',
  message: 'Nachricht',
  transfer: 'Weiterleiten',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
